// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__voSMG","footerLabel":"Footer_footerLabel__1XcA_"};